import {getUserData} from "Services/API";

export const DEFAULT_NATIONAL_PERCENTILE_CUTS = {
  state: "US",
  label: "National Norms",
  cutscores: {
    red: 0,
    yellow: 25,
    green: 75
  }
}

export function getStatePercentileCuts() {
  const {statePercentileCuts} = getUserData();
  //### Restore this if/when we want to give users a choice: return statePercentileCuts ? [DEFAULT_NATIONAL_PERCENTILE_CUTS, ...statePercentileCuts] : null;
  return statePercentileCuts ? statePercentileCuts : null;
}